import { render, staticRenderFns } from "./ztAccordionItem.vue?vue&type=template&id=b6f253fa&"
import script from "./ztAccordionItem.vue?vue&type=script&lang=js&"
export * from "./ztAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../admin/public/onboarding/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports